<ion-app>
  <ion-split-pane contentId="mainContent" when="lg">
    <ion-menu
      class="left-menu"
      contentId="mainContent"
      menuId="leftMenu"
      side="start"
      [disabled]="false"
    >
      <ion-header class="ion-no-border">
        <ion-toolbar>
          <div class="logo-container">
            <ion-img
              class="logo"
              src="assets/logo.png"
              alt="POSMWorks Logo"
            ></ion-img>
          </div>
        </ion-toolbar>
      </ion-header>

      <ion-content>
        <div class="search-container">
          <ion-searchbar
            placeholder="Search menu..."
            (ionInput)="handleSearch($event)"
            [value]="searchQuery()"
            class="menu-search"
            [debounce]="300"
            clear-icon="close-circle"
          ></ion-searchbar>
        </div>

        <ion-list class="ion-no-padding menu-list">
          @if (filteredMenuData().length > 0) {
            @for (item of filteredMenuData(); track item.id) {
              @if (item.type === 'single') {
                <!-- Single menu item without accordion -->
                <ion-menu-toggle auto-hide="false">
                  <ion-item
                    [routerLink]="[item.path]"
                    routerLinkActive="active-item"
                    lines="none"
                    detail="false"
                    class="single-menu-item"
                  >
                    <ion-icon [name]="item.icon" slot="start"></ion-icon>
                    <ion-label>{{ item.title }}</ion-label>
                  </ion-item>
                </ion-menu-toggle>
              } @else {
                <!-- Section with accordion -->
                <ion-accordion-group>
                  <ion-accordion
                    [value]="item.id"
                    [expanded]="item.isExpanded"
                  >
                    <ion-item slot="header" color="light">
                      <ion-icon [name]="item.icon" slot="start"></ion-icon>
                      <ion-label>{{ item.title }}</ion-label>
                    </ion-item>

                    <div class="ion-padding-vertical menu-items" slot="content">
                      @for (subItem of item.items; track subItem.id) {
                        <ion-menu-toggle auto-hide="false">
                          <ion-item
                            [routerLink]="[subItem.path]"
                            routerLinkActive="active-item"
                            lines="none"
                            detail="false"
                          >
                            <ion-icon [name]="subItem.icon" slot="start"></ion-icon>
                            <ion-label>{{ subItem.title }}</ion-label>
                          </ion-item>
                        </ion-menu-toggle>
                      }
                    </div>
                  </ion-accordion>
                </ion-accordion-group>
              }
            }
          } @else {
            <div class="empty-search">
              <ion-icon name="search-outline" class="empty-icon"></ion-icon>
              <h4>No Results Found</h4>
              <p>Try different keywords or check the spelling</p>
            </div>
          }
          <!-- <ion-accordion-group>
            <ion-accordion [value]="'asset-management'">
              <ion-item slot="header" color="light">
                <ion-icon name="briefcase-outline" slot="start"></ion-icon>
                <ion-label>Asset Management</ion-label>
              </ion-item>
              <div class="ion-padding-vertical menu-items" slot="content">
                <ion-menu-toggle auto-hide="false">
                  <ion-item
                    routerLink="/posm"
                    routerLinkActive="active-item"
                    lines="none"
                    detail="false"
                  >
                    <ion-icon name="list-outline" slot="start"></ion-icon>
                    <ion-label>POSM List</ion-label>
                  </ion-item>
                </ion-menu-toggle>
              </div>
            </ion-accordion>
          </ion-accordion-group> -->
        </ion-list>
      </ion-content>

      <ion-footer class="ion-no-border">
        <ion-toolbar>
          <div class="version-info">
            <ion-note color="medium">{{ versionInfo() }}</ion-note>
          </div>
          <ion-menu-toggle auto-hide="false">
            <ion-item
              button
              (click)="handleLogout()"
              lines="none"
              detail="false"
              color="light"
              class="logout-button"
            >
              <ion-icon
                name="log-out-outline"
                slot="start"
                color="danger"
              ></ion-icon>
              <ion-label color="danger">Logout</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-toolbar>
      </ion-footer>
    </ion-menu>

    <ion-router-outlet [animated]="true" id="mainContent"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
